import { jsx as _jsx } from 'react/jsx-runtime.js';
import { SocialGoogleButton } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { googleAuthUrl } from '../../../../redux/features/google/service/index.js';
import { useAppSelector } from '../../../../redux/hooks.js';
import { isGoogleEnabledSelector, currentLocaleSelector, } from '../../../../redux/core/siteConfig/siteConfigSlice.js';
import { keepMeInformedSelector } from '../../registrationSlice.js';
import { loginSourceSelector, redirectionUrlSelector, } from '../../../../redux/core/sourceData/sourceDataSlice.js';
import { buildGoogleOverwritedRedirectionUrl } from '../../../../redux/features/google/buildGoogleOverwritedRedirectionUrl.js';
import { useCurrentUrl } from '../../../../helpers/url/useCurrentUrl.js';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
import { activeWrapperSelector } from '../../../../redux/core/wrapperContext/wrapperContextSlice.js';
export const RegistrationWithGoogle = () => {
    const { t } = useTranslation();
    const isGoogleEnable = useAppSelector(isGoogleEnabledSelector);
    const checkboxState = useAppSelector(keepMeInformedSelector);
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    const loginSource = useAppSelector(loginSourceSelector);
    const currentLocale = useAppSelector(currentLocaleSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const currentUrl = useCurrentUrl();
    const overwritedRedirectionUrl = buildGoogleOverwritedRedirectionUrl(activeWrapper, redirectionUrl, currentUrl);
    const { trackBtnClick } = useTrack('standard');
    const onGoogleButtonClick = () => {
        trackBtnClick({ uniqueName: 'registerWithGoogle' });
    };
    return isGoogleEnable ? (_jsx(SocialGoogleButton, { "data-testid": "google-register-btn", as: "a", a11yLabel: "Login with google button", href: googleAuthUrl({
            loginSource,
            redirectionUrl: overwritedRedirectionUrl,
            currentLocale,
            checkboxState,
            currentUrl,
            formType: 'register',
        }), isFullWidth: true, size: ['medium'], onClick: onGoogleButtonClick, children: t('loginregistration.registration.googleButton') })) : null;
};
//# sourceMappingURL=RegistrationWithGoogle.js.map